import { render, staticRenderFns } from "./ProfitReview.vue?vue&type=template&id=96e1f830&"
import script from "./ProfitReview.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProfitReview.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports